/**
 * Product library — admin-gated for now while the flow settles; drop the AdminGate to open it
 * to all users.
 *
 * @feature-spec brain/vidmax/feature-specs/products.md
 */
import { createFileRoute } from "@tanstack/react-router"
import { AixContentBody } from "@aix/ui"
import { useAtomValue } from "jotai"
import type { ReactElement } from "react"

import AdminGate from "~/components/AdminGate"
import { BreadcrumbBanner } from "~/components/BreadcrumbBanner"
import CustomHead from "~/components/SEOHead/CustomHead"
import { ProductsListPage } from "~/components/Products/ProductsListPage"
import { navStyleAtom } from "~/context/jotai"
import AppLayout from "~/layouts/AppLayout"

function ProductsPage(): ReactElement {
  // Two-tier nav already renders the plan/credits header; a second banner duplicates it (VM-1005).
  const navStyle = useAtomValue(navStyleAtom)

  return (
    <>
      <CustomHead title="Products" />
      {navStyle !== "twoTier" && <BreadcrumbBanner items={[{ label: "Products" }]} />}
      <AixContentBody>
        <AdminGate>
          <ProductsListPage />
        </AdminGate>
      </AixContentBody>
    </>
  )
}

function ProductsPageWrapper(): ReactElement {
  return (
    <AppLayout>
      <ProductsPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/products")({
  component: ProductsPageWrapper,
})
